/** Strip HTML and truncate for meta description (~160 chars). */
export const htmlToMetaDescription = (html: string, max = 160): string => {
  const text = html
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!text) return "";
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1).trim()}…`;
};
